<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="productName">
        <el-input v-model="queryParams.productName" clearable placeholder="名称"></el-input>
      </el-form-item>
      
      <el-form-item  prop="channel" >
        <el-select v-model="queryParams.channel" filterable clearable placeholder="渠道" @change="search">
          <el-option
              v-for="item in channelData"
              :key="item.id"
              :label="item.name"
              :value="item.channel"
            ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="productType" >
        <el-select v-model="queryParams.productType" filterable clearable placeholder="资费类型" @change="search">
          <el-option label="累计套餐" value="1"></el-option>
          <el-option label="月套餐" value="2"></el-option>
          <el-option label="加油包" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleCreate" v-hasPermi="['product:add']">添加</el-button>
      </el-form-item>
    </el-form>
    <div class="table">
      <el-table :data="tableData" border id="out-table">
        <el-table-column prop="ids" label="ID" align="center" width="60px"></el-table-column>
        <el-table-column prop="productName" label="名称" align="center" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <p>{{row.productName}}</p>
            <p v-if="row.channel == 'cmlink' || row.channel == 'Quadcell'" style="color:#C0C4CC;">{{row.externalProductId}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="productType" label="类型" align="center" width="100px"></el-table-column>
        <el-table-column prop="flowCount" label="流量" align="center" width="100px"></el-table-column>
        <el-table-column prop="showFlowCount" label="展示流量" align="center" v-if="adminShow" width="100px"></el-table-column>
        <el-table-column prop="validityTime" label="有效期（天）" align="center" width="100px"></el-table-column>
        <!-- <el-table-column prop="products" label="国际站价格" align="center" width="620px">
            <template slot-scope="{row}">
              <div class="product-list">
                <div class="product-item" v-for="(item,index) in row.products.slice(0, 3)" :key="index"  
                      :title="'【'+item.countryName+'】' +' 售价('+item.currencySymbal + item.price +')'">
                      <span>【{{item.countryName}}】：  售价({{item.currencySymbal}}{{item.price}})</span>
                </div>
                <span class="el-dropdown-link" v-if="row.products.length>3" @click="showMoreProduct(row)">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                </span>
              </div>
            </template>
        </el-table-column> -->
        <el-table-column prop="voiceTotal" label="语音（分）" align="center" width="100px"></el-table-column>
        <el-table-column prop="total" label="短信（条）" align="center" width="100px"></el-table-column>
        <el-table-column prop="smsMo" label="短信MO（条）" align="center" width="120px"></el-table-column>
        <el-table-column prop="smsMt" label="短信MT（条）" align="center" width="120px"></el-table-column>

        <el-table-column prop="channel" label="渠道" align="center" width="100px" v-if="adminShow">
          <template slot-scope="{row}">
            <span v-if="row.channel == 'cmlink'">ZY国际</span>
            <span v-if="row.channel == 'cmBrazil'">中移巴西</span>
            <span v-if="row.channel == 'multi'">RX国际</span>
            <span v-if="row.channel == 'Quadcell'">QC国际</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="80px">
          <template slot-scope="{row}">
            <el-tag>{{row.status}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right" v-if="checkPermi(['product:add:price','product:edit'])">
          <template slot-scope="{row}">
            <p v-hasPermi="['product:copy']"><el-link icon="el-icon-document-copy"  type="primary" :underline="false" @click="handleCopy(row.id)">复制</el-link></p>
            <p v-hasPermi="['product:edit']"><el-link v-if="row.editable" type="primary" :underline="false"  icon="el-icon-edit"  @click="handleEdit(row.id)">编辑</el-link></p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="queryInfo"
    />

    <el-dialog title="区域价格列表" :visible.sync="moreProductOpen" width="900px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchQuery" clearable style="width: 30%"></el-input>
      <el-table :key="tableKey" :data="filteredTableData" height="650"  style="width: 100%">
        <el-table-column prop="countryName" label="使用区域"></el-table-column>
        <el-table-column prop="currency" label="收款货币代码" ></el-table-column>
        <el-table-column prop="currencySymbal" label="收款货币符号"></el-table-column>
        <el-table-column prop="price" label="售价"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {productPage , listChannel } from "@/api/api.js"; //套餐列表
import {operatorList} from "@/api/international.js";
export default {
  name: "internationalProduct",
  data() {
    return {
      channelData:[],
      // 查询条件
      queryParams: {
        productName:undefined,
        operationId:undefined,
        productType:undefined,
        type:'3',
        countryId:undefined,
        channel:undefined,
        productType:undefined
      },
      optOperatorList:[],
      optType: [],
      isDisable: [
        { value: 0, label: "已禁用" },
        { value: 1, label: "启用中" }
      ],
      // 分页器
      page: 1,
      pageSize: 20,
      total: 20,
      // 列表数据
      tableData: [],
      open:false,
      moreProductOpen:false,
      moreProductData:[],
      searchQuery:'',
       tableKey: 0,
    };
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
    filteredTableData() {
      if (!this.moreProductData) return [];
      return this.moreProductData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    }
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'internationalProduct'){
          this.queryInfo();
        }
      },
      // 深度观察监听
      deep: true
    },
    moreProductData() {
      this.tableKey++;
    }
  },
  methods: {
    initChannel(){
      let operatorId = '4'
      listChannel({operatorId}).then(res=>{
        this.channelData = res.data.data
      })
    },
    // 状态转换
    transferIsDisable(status) {
      let obj = {
        0: "未启用",
        1: "启用中"
      };
      return obj[status];
    },
    //国家运营商列表
    selectOperatorList(){
      operatorList({type:'2'}).then(res =>{
        this.optOperatorList = res.data.data;
      })
    },
    
    // 获取列表
    queryInfo() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      productPage(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index) => {
            item.flowCount = this.formatFlow(item.flowCount);
            item.showFlowCount = this.formatFlow(item.showFlowCount);
            if(this.adminShow){
              item.ids = item.id;
            }else{
              item.ids = index + 1;
            };
            item.status = this.transferIsDisable(item.status);
          })
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    formatFlow(flow){
      if(!flow){
        return null;
      }
      if(0 > flow){
        flow = "畅享";
      }else if(1024 > flow > 0){
        flow = flow + 'M';
      }else if(flow >= 1024){
        flow = (flow/1024).toFixed(2) + 'G';
      }
      return flow;
    },
    // 添加
    handleCreate() {
      this.$router.push({ path: `/internationalProduct/add` });
    },
    // 编辑
    handleEdit(id) {
      this.$router.push({ path: `/internationalProduct/edit/`+id });
    },
    handleCopy(id) {
      this.$router.push({ path: `/internationalProduct/copy/`+id });
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.queryInfo();
    },
    // 搜索
    search() {
      this.page = 1;
      this.queryInfo();
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.resetForm("form");
    },
    showMoreProduct(item){
      this.moreProductOpen = true
      this.searchQuery = '';
      this.moreProductData = [];
      this.$nextTick(() => {
        // 使用展开运算符创建新数组
        this.moreProductData = [...item.products]; 
        this.tableKey++;
      });
    },
  },
  mounted() {

  },
  created() {
    this.initChannel()
    this.selectOperatorList();
    this.queryInfo();

  }
};
</script>
<style scoped lang="less">
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 620px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 290px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}

.expand-content {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  gap: 10px 15px; 
}

.expand-item {
  flex: 0 0 calc(15% - 12px);
  display: flex;
  margin-bottom: 5px; 
  align-items: center;
  
  .label {
    color: #606266;
    width: 100px;
    text-align: right;
    margin-right: 10px;
  }
  
  .value {
    color: #303133;
    display: flex;
    align-items: center;
  }
}
</style>